import {useEffect, useMemo, useRef, useState} from 'react';
import {GetAllCafeterias} from '../../../../reduxToolkit/FoodieShift/FoodieShiftApi';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import useWebSocket from './useWebSocket';
import {toast} from 'react-toastify';
import {CheckOutOrderKitchen} from '../../../../reduxToolkit/FoodieIngredient/IngredientApi';
import {getFullName, postSessionStorageLoader} from "../../../../Apis/functions";
import {getDateLong} from '../../../../Apis/functions';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model item: model of header section
 * @param useState search: Variable for searching the items
 * @param boolean isOnline: Variable that indicates whether the WebSocket is open
 * @param useState setIsOnline: Variable to update the WebSocket state when it opens or closes
 * @param boolean isReload: State that updates whether a manual WebSocket connection is required
 * @param boolean activeStep: Variable to indicate which tab is active
 */
const OrderApp = ({item, search, isOnline, setIsOnline, modified, setModified, activeStep}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const elementRef = useRef(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [scheduleOrders, setScheduleOrders] = useState(0);
    const [serverOrders, setServerOrders] = useState(0);
    const [pendingOrders, setPendingOrders] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchId, setSearchId] = useState('txt_oa_search_order'); // Set the search input ID
    const { orders, reconnectWebSocket } = useWebSocket({
        item,
        isOnline,
        setIsOnline,
        setScheduleOrders,
        setServerOrders,
        setPendingOrders,
    });
    useEffect(() => {
        if (!item?.cafeteria?.id) return;
        setScheduleOrders(0);
        setServerOrders(0);
        postSessionStorageLoader(true);
    }, [item?.cafeteria?.id, item?.date]);

    /**
     * Search control over the order list
     * @type {unknown}
     */
    const withSearchOrders = useMemo(() => {
        if (!search) return orders;

        const lowerSearch = search.toLowerCase();
        return orders.filter(order => {
            const fullName =  order?.userFullName?.toLowerCase() ||
                getFullName(order?.userName, order?.userLastName, order?.userSecondLastName) ||
                getFullName(order?.requestedByName, order?.requestedByLastName, order?.requestedBySecondLastName);

            return  fullName?.toLowerCase().includes(lowerSearch);
        }

        );
    }, [search, orders]);


    /**
     * Dispatch action to get all available diner
     */
    useEffect(() => {
        dispatch(GetAllCafeterias());
    }, []);

    /**
     * Reconnect WebSocket on connection failure
     */
    useEffect(() => {
        if(modified && activeStep == 0){
            if(!item?.cafeteria?.id || typeof item?.cafeteria?.id == 'undefined'){
                toast.warn(t("you_must_select_a_diner"));
                return;
            }
            reconnectWebSocket();
            setModified(false);
        }
    }, [modified]);

    /**
     * Handle to complete a ticket
     * @param item
     */
    const handleMarkAsCompleted = (value) => {
        dispatch(CheckOutOrderKitchen({id: value.id, date: getDateLong(item?.date)})).then(({payload:{data:{success}}}) => {
            if(success){
                toast.success(t("has_been_completed_successfully"));
            }
        });
    }

    return {
        t,
        elementRef,
        orders,
        withSearchOrders,
        scheduleOrders,
        serverOrders,
        pendingOrders, 
        handleMarkAsCompleted,
        DEV,
        permission,
        searchId,
    };
};

export default OrderApp
